module.exports = __webpack_public_path__ + "static/media/empty_form_list.ecc00267.png";